import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs'
import { logger } from '../utils/console';

import { AnalizePDFResponse, AnalizePDFUltrasonograResponse, ArquivoAnalisado, CartaoGestante, ConsultaPaciente, Exame, ExameClinico, ExameConfiance, ExameLaboratorio, Exames, ExameUltrasom, Paciente, ResultPDF, UltrasonografiaConfiance } from '../interfaces/pacient-info.interface'
import { APIInterface } from '../interfaces/api/api.interface'
import { Usuario } from '../interfaces/usuario.interface'
import { ApiService } from './api.service'
import { ListaConsulta } from '../interfaces/listaconsulta.interface'
import { Secretaria } from '../interfaces/secretaria.interface'
import { Medico } from '../interfaces/medico.interface'
import { Enfermeiro } from '../interfaces/enfermeiro.interface'
import { Pagination } from '../interfaces/pagination.interface'
import { Acesso } from '../interfaces/acesso.interface'
import { Organizacao, TipoView } from '../interfaces/organizacao.interface'
import { FuseNavigationItem } from '@fuse/types'
import { Super } from '../interfaces/super.interface'

interface LoginType {
  accessToken: string,
  refreshToken: string,
  token: string,
  expiresIn: number,
  data: {
    _id: string, 
    name: string, 
    email: string, 
    permissao: TipoView
  }
}
interface codeType {
  success: boolean,
  message: string,
  needCode: boolean,
}

export interface OrgType {
  id: string;
  name: string;
  instituicao_publica: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class APIGestaCardService implements APIInterface {

  constructor(
    private _api: ApiService,
    private _http: HttpClient
  ) { }

  GetMenuOptions(): Promise<FuseNavigationItem> {

    return new Promise((resolve, reject) => {
      this._api.get('/api/menu').subscribe(result => {

        let menu: FuseNavigationItem = result.data
        
        if (!menu) reject('Nenhum menu encontrado')
        
        resolve(menu)

      }, err => reject(err))
  
    })
  }

  GetMenuOptionsObs(): Observable<FuseNavigationItem> {

    return Observable.create((observer: any) => {
      
      this._api.get('/api/menu').subscribe(result => {

        let menu: FuseNavigationItem = result.data
        
        if (!menu) observer.error('Nenhum menu encontrado')
        
        observer.next(menu)

      }, err => observer.error(err))
  
    })
  }

  GetMe(): Promise<Usuario> {

    return new Promise((resolve, reject) => {
      this._api.get('/api/auth/me').subscribe(result => {

        let usuario: Usuario = result.data
        
        if (!usuario) reject('Nenhum usuario encontrado')

        if (usuario.tipo_usuario === 'super') reject('O seu tipo de usuario não pode acessar esse aplicativo')
        
        resolve(usuario)

      }, err => reject(err))

    })

  }

  GetMeObs(): Observable<Usuario> {

    return Observable.create((observer: any) => {
      
      this._api.get('/api/auth/me').subscribe(result => {

        let usuario: Usuario = result.data
        
        if (!usuario) observer.error('Nenhum usuario encontrado')
        
        observer.next(usuario)

      }, err => observer.error(err))
  
    })
  }

  GetUsuarioPorId(id: string): Promise<Super | Medico | Enfermeiro | Secretaria | Paciente> {

    return new Promise((resolve, reject) => {
      this._api.get(`/api/usuarios/${id}`).subscribe(result => {

        let usuario: Super | Medico | Enfermeiro | Secretaria | Paciente = result.data
        
        if (!usuario) reject('Nenhum usuario encontrado')

        if (usuario.tipo_usuario === 'super') reject('O seu tipo de usuario não pode acessar esse aplicativo')
        
        resolve(usuario)

      }, err => reject(err))

    })

  }

  EmailExists(email: string): Promise<Boolean> {
    
    return new Promise((resolve, reject) => {

      this._api.get('/api/auth/checkEmail', { email }).subscribe(result => {

        let exists: Boolean = result.success

        resolve(exists)

      }, err => reject(err))

    })
  }

  GetNewAccessToken(): Promise<Boolean> {
      
    return new Promise((resolve, reject) => {

      const refreshToken = localStorage.getItem('refreshToken')

      if (refreshToken) {
        this._api.get('/api/auth/token', { refreshToken: refreshToken }).subscribe(result => {
  
          if (!result.accessToken || !result.refreshToken) reject('Nenhum token encontrado')
  
          localStorage.setItem('accessToken', result.accessToken);
          localStorage.setItem('refreshToken', result.refreshToken);
          localStorage.setItem('expiresIn', (new Date().getTime() + result.expiresIn).toString());
  
          resolve(true)
  
        }, err => reject(err))
      }

    })

  }

  GetNewAccessTokenObs(): Observable<Boolean> {

    return Observable.create((observer: any) => {

      const refreshToken = localStorage.getItem('refreshToken')

      if (refreshToken) {

        this._api.get('/api/auth/token', { refreshToken: refreshToken }).subscribe(result => {
  
          let data = result.data
  
          if (!data) observer.error('Nenhum token encontrado')
  
          localStorage.setItem('accessToken', data.accessToken)
          localStorage.setItem('refreshToken', data.refreshToken);
          localStorage.setItem('expiresIn', (new Date().getTime() + result.expiresIn).toString());
  
          observer.next(true)
  
        }, err => observer.error(err))
        
      }
    })

  }


  ChecarUsuario(email: string): Promise<Boolean> {

    return new Promise((resolve, reject) => {
        
      this._api.post('/api/auth/checkUser', { email, device: 'app' }).subscribe(result => {

        let exists: Boolean = result.needCode

        resolve(exists)

      }, err => reject({ message: err }))
    })

  }

  EnviarCodigo(email: string): Promise<Boolean> {
      
    return new Promise((resolve, reject) => {

      this._api.post('/api/auth/sendCode', { email }).subscribe(result => {

        let sent: Boolean = result.success

        resolve(sent)

      }, err => reject(err))

    })

  }

  AlterarSenha(senhaAtual: string, senhaNova: string, confirmaSenhaNova: string): Promise<Usuario> {
      
    return new Promise((resolve, reject) => {

      this._api.post('/api/auth/alterPassword', { password: senhaAtual, newPassword: senhaNova, confirmNewPassword: confirmaSenhaNova }).subscribe((result) => {
        let usuario: Usuario = result.data

        if (!usuario) reject('Não foi possivel pegar o usuario')

        resolve(usuario)

      }, err => {
        reject(err.error)
      })

    })
  
  }

  AlterarEmailDeUsuario(email_novo: string, password: string): Promise<Usuario | null> {

    return new Promise((resolve, reject) => {

      this._api.post('/api/auth/alterEmail', { newEmail: email_novo, password }).subscribe((result) => {

        var usuario: Usuario = result.data

        if (!usuario) resolve(null)

        resolve(usuario)

      }, err => reject(err))

    })

  }

  VerificarCodigo(email: string, code: string): Promise<Boolean> {
    
    return new Promise((resolve, reject) => {

      this._api.post('/api/auth/verifyCode', { email, code }).subscribe(result => {

        let verified: Boolean = result.verified

        resolve(verified)

      }, err => reject(err))

    })

  }

  VerificarCodigoEAlterarSenha(email: string, verificationCode: string, newPassword: string): Promise<Boolean> {

    return new Promise ((resolve, reject) => {

      this._api.post('/api/auth/verifyCodeAndSetPassword ', { email, verificationCode, newPassword }).subscribe(result => {

        let verified: Boolean = result.success

        resolve(verified)

      }, err => reject(err))

    })

  }

  AtualizaSenha(email: string, verificationCode: string, newPassword: string): Promise<Boolean> {

    return new Promise((resolve, reject) => {

      this._api.post('/api/auth/verifyCodeAndSetPassword', { email, verificationCode, newPassword }).subscribe(result => {
        let status = result.success

        resolve(status)

      }, err => reject({ message: err }))

    })

  }

  UploadImage(file: File): Promise<string> {

    return new Promise((resolve, reject) => {

      const formData: FormData = new FormData();
      formData.append('url', file, file.name);

      this._api.post('/api/upload', formData).subscribe(result => {

        if (!result.data) reject('Nenhuma imagem encontrada')

        resolve(result.data.path)

      }, (err) => reject(err))

    })
  }

  GetOrgsForLogin(email: string, senha: string): Promise<OrgType[]> {

    return new Promise((resolve, reject) => {

      this._api.post('/api/auth/orgs', { email, password: senha }).subscribe((result: any) => {

        const orgs: OrgType[] = Array.isArray(result) ? result : result.data;

        if (!orgs || orgs.length === 0) reject('Nenhuma organização encontrada para este usuário');

        resolve(orgs);

      }, err => reject(err));

    });

  }

  signInWithEmailAndPassword(email: string, senha: string, orgId?: string): Promise<LoginType|codeType> {

    return new Promise((resolve, reject) => {

      const body: any = { email, password: senha };
      if (orgId) body.org = orgId;
      
      this._api.post('/api/auth/login', body).subscribe(async (result: LoginType|codeType) => {

        if (this.isCodeType(result)) {
          let code: codeType = result

          resolve(code)
        } else {
          let login: LoginType = result

          let dadosUsuario = login.data

          if (!['super', 'admin'].includes(dadosUsuario.permissao)) {
            if (window.innerWidth < 768) {
              localStorage.setItem('accessToken', result.token);
            } else {
              localStorage.setItem('accessToken', result.accessToken);
              localStorage.setItem('refreshToken', result.refreshToken);
              localStorage.setItem('expiresIn', (new Date().getTime() + result.expiresIn).toString());
            }

            resolve(result)
          }
        }

        reject('O seu tipo de usuario não pode acessar esse aplicativo')

      }, err => reject(err))

    })

  }

  /**
   * Valida token e retorna dados do usuário
   * ATENÇÃO: Este método SALVA o token no localStorage, afetando a sessão do navegador
   * Para webview, use validateTokenWithoutLogin() em vez deste método
   */
  signInWithToken(token: string): Promise<Usuario> {
      
      return new Promise((resolve, reject) => {
        if (!token || token.trim() === '') {
          reject({ status: 400, message: 'Token não fornecido' });
          return;
        }

        logger.log('[APIGestaCard] Validando token...');
        this._api.setAuthorization(token);
  
        this._api.get('/api/auth/me').subscribe(result => {
          
          let usuario: Usuario = result.data;
          
          if (!usuario) {
            logger.error('[APIGestaCard] Nenhum usuário retornado pela API');
            this._api.setAuthorization('');
            reject({ status: 404, message: 'Usuário não encontrado' });
            return;
          }

          logger.log('[APIGestaCard] Usuário validado:', usuario.email, 'Tipo:', usuario.tipo_usuario);
          
          // Bloqueia super users e admins (apenas app de gestores)
          if (usuario.tipo_usuario === 'super') {
            logger.warn('[APIGestaCard] Tentativa de acesso de super user bloqueada');
            this._api.setAuthorization('');
            localStorage.removeItem('accessToken');
            reject({ status: 403, message: 'Super usuários não podem acessar este aplicativo' });
            return;
          }

          if (usuario.tipo_usuario === 'admin') {
            logger.warn('[APIGestaCard] Tentativa de acesso de admin bloqueada');
            this._api.setAuthorization('');
            localStorage.removeItem('accessToken');
            reject({ status: 403, message: 'Administradores não podem acessar este aplicativo' });
            return;
          }

          // Usuário válido
          resolve(usuario);
  
        }, err => {
          logger.error('[APIGestaCard] Erro na validação do token:', err);
          this._api.setAuthorization('');
          reject(err);
        })
  
      })
  }

  /**
   * Valida token SEM salvar no localStorage (para webview)
   * O token é lido automaticamente da URL pelo ApiService.getHeaders()
   * Uso: WebviewGuard para validar acesso temporário sem afetar sessão do navegador
   */
  validateTokenWithoutLogin(token: string): Promise<Usuario> {
      
      return new Promise((resolve, reject) => {
        if (!token || token.trim() === '') {
          reject({ status: 400, message: 'Token não fornecido' });
          return;
        }

        logger.log('[APIGestaCard] Validando token (webview - sem salvar sessão)...');
        
        // NÃO chama setAuthorization! O getHeaders() já pega a key da URL automaticamente
        this._api.get('/api/auth/me').subscribe(result => {
          
          let usuario: Usuario = result.data;
          
          if (!usuario) {
            logger.error('[APIGestaCard] Nenhum usuário retornado pela API');
            reject({ status: 404, message: 'Usuário não encontrado' });
            return;
          }

          logger.log('[APIGestaCard] Token webview validado:', usuario.email, 'Tipo:', usuario.tipo_usuario);
          
          // Bloqueia super users e admins
          if (usuario.tipo_usuario === 'super' || usuario.tipo_usuario === 'admin') {
            logger.warn('[APIGestaCard] Tentativa de acesso webview bloqueada para:', usuario.tipo_usuario);
            reject({ status: 403, message: 'Tipo de usuário não permitido para webview' });
            return;
          }

          // Usuário válido - token NÃO foi salvo no localStorage
          resolve(usuario);
  
        }, err => {
          logger.error('[APIGestaCard] Erro na validação do token webview:', err);
          reject(err);
        })
  
      })
  }

  sendPasswordResetEmail(email: string): Promise<Boolean> {
    return new Promise((resolve, reject) => {  
      this._api.post('/api/auth/forgotPassword', { email }).subscribe(() => {
        resolve(true)
      }, err => reject(err))
    })
  }

  isCodeType(result: any): result is codeType {
    return (
      result &&
      typeof result.success !== 'undefined' &&
      typeof result.message === 'string' &&
      typeof result.needCode === 'boolean'
    );
  }

  ConsultarPermissao(): Promise<string> {

    return new Promise((resolve, reject) => {

      this._api.get('/api/auth/permissao').subscribe(result => {

        if (result.data.length) {

          var usuario: Usuario = result.data[0]

          if (usuario.tipo_usuario) resolve(usuario.tipo_usuario)

        } else reject()

      }, (err) => reject(err))

    })

  }

  ConsultarPermissoAsObservable() : Observable<string> {

    return Observable.create(async (observer: any) => {  

      await this.ConsultarPermissao()
        .then((result) => observer.next(result))
        .catch((err) => observer.error(err))

    })

  }

  ConsultarDadosAcesso(token?: string): Promise<Acesso> {

    return new Promise((resolve, reject) => {
      if (token) this._api.setAuthorization(token)

      this._api.get('/api/auth/infoAccess').subscribe(result => {

        if (result.data) {

          var acesso: Acesso = result.data

          resolve(acesso)

        } else reject()

      }, (err) => reject(err))

    })

  }

  ConsultarDadosAcessoObservable(token?: string) : Observable<Acesso> {

    return Observable.create(async (observer: any) => {  

      await this.ConsultarDadosAcesso(token)
        .then((result) => observer.next(result))
        .catch((err) => observer.error(err))

    })

  }
  
  OrderByDate(consultas: ConsultaPaciente[]) : ConsultaPaciente[] {

    var ordered = consultas.sort((a,b) => a.data.getTime() - b.data.getTime()) 

    return ordered

  }

  IsCardActive(cartao_id: string) : Promise<boolean> {

    return new Promise((resolve) => {

      this._api.get(`/api/cartoes/${cartao_id}`).subscribe((result) => {

        if (!result.data) resolve(false)

        var cartao: CartaoGestante = result.data 
        
        resolve(cartao.ativado) 

      })

    })

  }

  FilterByActiveCard(consultas: ConsultaPaciente[]) : Promise<any> {

    return new Promise((resolve) => {

      var aux = consultas.map((item) => { 
        return this.IsCardActive(item.cartao_paciente_id)
      }) 

      Promise.all(aux).then((res) => {
        var filtered: ConsultaPaciente[] = []

        consultas.forEach((item, index) => {

          if (res[index]) filtered.push(item)

        })

        resolve(filtered) 
      })

    })

  }

  IsPreviousToday(date: Date) : boolean {

    var today = new Date() 

    return date.getTime() < today.getTime() 

  }

  DivideNextAndPrevious(consultas: ConsultaPaciente[]): ListaConsulta {
    
    var obj: ListaConsulta = {
      proximas: [], 
      anteriores: []
    }

    consultas.forEach((item) => {
      if (this.IsPreviousToday(item.data)) obj.anteriores.push(item) 
      else obj.proximas.push(item) 
    })

    return obj 

  }

  ConvertTimeStampToDate(ts: any) : Date | string {
    if (ts == '' || !ts) return ''

    var date = null

    if (typeof ts === 'string') {
      if (ts.split('T')[0]) {
        date = new Date(ts.split('T')[0] + 'T00:00:00')
      } else {
        date = new Date(ts)
      }
    } else {
      if (ts.seconds) date = new Date(ts.seconds * 1000)
      if (ts._seconds) date = new Date(ts._seconds * 1000)
    }

    if (!date) return ''

    return date 
  }

  FormatCartaoGestanteToDate(cartao: CartaoGestante) : CartaoGestante {
    var aux = cartao 
    aux.criado_em = aux.criado_em ? this.ConvertTimeStampToDate(aux.criado_em) : '' 

    // Atualizando sobre a gestação
    aux.sobre_a_gestacao.dum = aux.sobre_a_gestacao.dum ? this.ConvertTimeStampToDate(aux.sobre_a_gestacao.dum) : '' 
    aux.sobre_a_gestacao.us1 = aux.sobre_a_gestacao.us1 ? this.ConvertTimeStampToDate(aux.sobre_a_gestacao.us1) : '' 

    // Atualizando as vacins 
    aux.vacinas.tri_dose1 = aux.vacinas.tri_dose1 ? this.ConvertTimeStampToDate(aux.vacinas.tri_dose1) : '' 
    aux.vacinas.tri_dose2 = aux.vacinas.tri_dose2 ? this.ConvertTimeStampToDate(aux.vacinas.tri_dose2) : '' 
    aux.vacinas.tri_dose3 = aux.vacinas.tri_dose3 ? this.ConvertTimeStampToDate(aux.vacinas.tri_dose3) : ''
    
    aux.vacinas.hep_dose1 = aux.vacinas.hep_dose1 ? this.ConvertTimeStampToDate(aux.vacinas.hep_dose1) : '' 
    aux.vacinas.hep_dose2 = aux.vacinas.hep_dose2 ? this.ConvertTimeStampToDate(aux.vacinas.hep_dose2) : '' 
    aux.vacinas.hep_dose3 = aux.vacinas.hep_dose3 ? this.ConvertTimeStampToDate(aux.vacinas.hep_dose3) : '' 

    aux.vacinas.dt_dose1 = aux.vacinas.dt_dose1 ? this.ConvertTimeStampToDate(aux.vacinas.dt_dose1) : '' 
    aux.vacinas.dt_dose2 = aux.vacinas.dt_dose2 ? this.ConvertTimeStampToDate(aux.vacinas.dt_dose2) : '' 
    aux.vacinas.dt_dose3 = aux.vacinas.dt_dose3 ? this.ConvertTimeStampToDate(aux.vacinas.dt_dose3) : '' 

    aux.vacinas.colpo_data = aux.vacinas.colpo_data ? this.ConvertTimeStampToDate(aux.vacinas.colpo_data) : '' 

    aux.fim_data = aux.fim_data ? this.ConvertTimeStampToDate(aux.fim_data) : '' 

    aux.exames.clinicos = aux.exames.clinicos.map((item) => {
      var aux2: ExameClinico = { 
        ...item, 
        ...{
          id: item && item.id ? item.id : null,
          data: item && item.data ? this.ConvertTimeStampToDate(item.data) : ''
        }
      }
      return aux2
    })

    aux.exames.laboratorio = aux.exames.laboratorio.map((item) => this.FormatExameLaboratorioToDate(item))

    aux.exames.ultrasom = aux.exames.ultrasom.map((item) => {
      var aux2 = item

      aux2.data = this.ConvertTimeStampToDate(aux2.data)

      return aux2
    })
    
    return aux 
  }

  FormatExameLaboratorioToDate(laboratorial: ExameLaboratorio) : ExameLaboratorio {

    var aux2 = laboratorial

    if (!aux2) return aux2

    aux2.datas.data1 = this.ConvertTimeStampToDate(aux2.datas.data1)
    aux2.datas.data2 = this.ConvertTimeStampToDate(aux2.datas.data2)
    aux2.datas.data3 = this.ConvertTimeStampToDate(aux2.datas.data3)

    return aux2

  }

  FormatarConsulta(consulta: ConsultaPaciente) : ConsultaPaciente {
    var aux: any = consulta 

    aux.data = this.ConvertTimeStampToDate(aux.data)
    
    return aux 
  }
  
  /*****************************************************************************************************************************************
   * 
   *                                                                 ORGANIZAÇÃO
   * 
   *****************************************************************************************************************************************/
  PegarOrganizacaoPorId(orgId: string): Promise<Organizacao | null> {
    return new Promise((resolve, reject) => {
      this._api.get(`/api/orgs/${orgId}`).subscribe(result => {
        let organizacao: Organizacao = result.data
        if (!organizacao) resolve(null)
        resolve(organizacao)
      }, err => reject(err))
    })
  }

  PegarOrganizacaoLogada(): Promise<Organizacao | null> {
    return new Promise((resolve, reject) => {
      this._api.get(`/api/auth/meOrg`).subscribe(result => {
        let organizacao: Organizacao = result.data
        if (!organizacao) resolve(null)
        resolve(organizacao)
      }, err => reject(err))
    })
  }


  /*****************************************************************************************************************************************
   * 
   *                                                                 MÉDICOS
   * 
   *****************************************************************************************************************************************/
  CadastrarMedico(medico: Medico): Promise<any> {

    return new Promise(async (resolve, reject) => {

      this._api.post('/api/usuarios', medico).subscribe(result => {

        resolve(result.data) 

      }, err => reject(err))

    })

  }

  TotalCartoesUsadosPorMedico(medico_id: string): Promise<number | null> {

    return new Promise((resolve, reject) => {

      this._api.get('/api/cartoes', { medico: medico_id }).subscribe(result => {  
        
        let cartoesGestantes: Array<CartaoGestante> = result.data
        
        if (!cartoesGestantes.length) resolve(null) 

        var filtrado = cartoesGestantes.filter(cartao => cartao.ativado) 

        resolve(filtrado.length) 

      }, err => reject(err))

    })

  }

  PegarTotalMedicos(): Promise<number> {
      
    return new Promise((resolve, reject) => {

      this._api.get('/api/usuarios', { tipoUsuario: 'medico', count: true }).subscribe(result => {

        let medicosCount: number = result.data

        resolve(medicosCount)

      }, err => reject(err))

    })

  }

  PegarListaMedicos(): Observable<Medico[]> {

    return Observable.create((observer: any) => {

      this._api.get('/api/usuarios', { tipoUsuario: 'medico' }).subscribe(result => {

        let medicos: Array<Medico> = result.data

        if (medicos.length) {

          var medicosEditados = medicos.map((item) => {
            if (item.idade) item.idade = this.ConvertTimeStampToDate(item.idade)

            return item
          }) 

          medicosEditados.sort((a,b) => a.primeiro_nome > b.primeiro_nome ? 1 : -1) 

          observer.next(medicosEditados ? medicosEditados : []) 
          observer.complete() 

        }

      }, err => observer.error(err))

    })

  }

  PegarUmMedicoPorEmail(email_medico: string, token?: string): Promise<Medico | null> {

    return new Promise((resolve, reject) => {
      if (token) this._api.setAuthorization(token);

      if (!email_medico) {
        resolve(null);
        return
      }

      this._api.get('/api/usuarios', { tipoUsuario: 'medico', email: email_medico}).subscribe((result) => {
        if (!result.data) resolve(null)

        let medicos: Array<Medico> = result.data

        if (medicos.length != 0) {
          let medico = medicos[0] 

          if (medico.idade) medico.idade = this.ConvertTimeStampToDate(medico.idade) 

          resolve(medico) 

        } else resolve(null)

      }, err => reject(err))

    })

  }

  PegarUmMedicoPorId(id_medico: string): Promise<Medico> {

    return new Promise((resolve, reject) => {

      this._api.get(`/api/usuarios/${id_medico}`).subscribe(result => {

        let medico: Medico = result.data

        if (medico.idade) medico.idade = this.ConvertTimeStampToDate(medico.idade) 

        resolve(medico)

      }, err => reject(err))

    })

  }

  PegarListaPacientesDeUmMedico(medicoId: string): Observable<Paciente[]> {
    
    return Observable.create(async (observer: any) => {

      try {

        this._api.get('/api/usuarios', { tipoUsuario: 'paciente', medico: medicoId, detailCartao: true }).subscribe(result => {
          
          var pacientes: Array<Paciente> = result.data

          var pacientesEditado = pacientes.map((item) => {

            item.cartao_gestante = (item.cartao_gestante || []).map(cartao => this.FormatCartaoGestanteToDate(cartao))

            item.ultimo_cartao = item.cartao_gestante.length > 0 ? item.cartao_gestante[0] : undefined

            if (item.idade) item.idade = this.ConvertTimeStampToDate(item.idade)
            
            return item

          })

          pacientesEditado.sort((a,b) =>  a.primeiro_nome > b.primeiro_nome ? 1 : -1)

          observer.next(pacientesEditado) 

        })

      } catch (error) {
        observer.error(error) 
      }
      
    })

  }

  PegarListaPacientesDeUmMedicoPage(page: number = 1, limit: number = 12, search: object = {}): Observable<Pagination<Paciente>> {
  
    return Observable.create(async (observer: any) => {
      try {
        const postData = { ...search, page, limit, detailCartao: true, tipoUsuario: 'paciente'}

        this._api.get('/api/usuarios/page', postData).subscribe(result => {
          const { page, data, total, totalInPage, totalPages } = result
            
          var pacientes: Array<Paciente> = data

          var pacientesEditado = pacientes.map((item) => {

            item.cartao_gestante = (item.cartao_gestante || []).map(cartao => this.FormatCartaoGestanteToDate(cartao))
            
            item.ultimo_cartao = item.cartao_gestante.length > 0 ? item.cartao_gestante[0] : undefined

            if (item.idade) item.idade = this.ConvertTimeStampToDate(item.idade)
            
            return item

          })

          pacientesEditado.sort((a,b) =>  a.primeiro_nome > b.primeiro_nome ? 1 : -1)

          const pagination: Pagination<Paciente> = {
            data: pacientesEditado,
            totalInPage,
            totalPages,
            total,
            page
          }

          observer.next(pagination) 

        })

      } catch (error) {
        observer.error(error) 
      }
    })
  }

  PegarCartoesGestanteDoMedico(email_medico: string ): Promise<any> {
    return new Promise((resolve, reject) => {
        // this.firestore.collection('cartao_gestante', ref => ref.where())
    })
  }

  ProximaConsultaMedico(email_medico: string): Promise<ConsultaPaciente | null> {

    return new Promise(async (resolve, reject) => {

      try {
          var consultas = await this.ListaConsultasMedico(email_medico)

          var proximas_consultas = consultas.proximas 
          
          if (proximas_consultas.length > 0) resolve(proximas_consultas[0]) 
          else resolve(null) 

      } catch (error) {

        reject(error)

      }

    })

  }

  AtualizarMedico(medico: Medico): Promise<Medico> {

    return new Promise((resolve, reject) => {

      this._api.put(`/api/usuarios/${medico.id}`, medico).subscribe(result => {

        let medico: Medico = result.data

        resolve(medico) 
        
      }, err => reject(err))

    })

  }

  DeletarMedico(medico: Medico): Promise<Boolean> {
    return new Promise((resolve, reject) => {

      this._api.delete('/api/usuarios', medico.id!).subscribe(() => {

        resolve(true) 

      }, err => reject(err)) 

    })
  }  
  

  /*****************************************************************************************************************************************
   * 
   *                                                                 ENFERMEIROS
   * 
   *****************************************************************************************************************************************/
  CadastrarEnfermeiro(enfermeiro: Enfermeiro): Promise<any> {

    return new Promise(async (resolve, reject) => {

      this._api.post('/api/usuarios', enfermeiro).subscribe(result => {

        resolve(result.data) 

      }, err => reject(err))

    })

  }

  TotalCartoesUsadosPorEnfermeiro(enfermeiro_id: string): Promise<number | null> {

    return new Promise((resolve, reject) => {

      this._api.get('/api/cartoes', { enfermeiro: enfermeiro_id }).subscribe(result => {  
        
        let cartoesGestantes: Array<CartaoGestante> = result.data
        
        if (!cartoesGestantes.length) resolve(null) 

        var filtrado = cartoesGestantes.filter(cartao => cartao.ativado) 

        resolve(filtrado.length) 

      }, err => reject(err))

    })

  }

  PegarTotalEnfermeiros(): Promise<number> {
      
    return new Promise((resolve, reject) => {

      this._api.get('/api/usuarios', { tipoUsuario: 'enfermeiro', count: true }).subscribe(result => {

        let enfermeirosCount: number = result.data

        resolve(enfermeirosCount)

      }, err => reject(err))

    })

  }

  PegarListaEnfermeiros(): Observable<Enfermeiro[]> {

    return Observable.create((observer: any) => {

      this._api.get('/api/usuarios', { tipoUsuario: 'enfermeiro' }).subscribe(result => {

        let enfermeiros: Array<Enfermeiro> = result.data

        if (enfermeiros.length) {

          var enfermeirosEditados = enfermeiros.map((item) => {
            if (item.idade) item.idade = this.ConvertTimeStampToDate(item.idade)

            return item
          }) 

          enfermeirosEditados.sort((a,b) => a.primeiro_nome > b.primeiro_nome ? 1 : -1) 

          observer.next(enfermeirosEditados ? enfermeirosEditados : []) 
          observer.complete() 

        }

      }, err => observer.error(err))

    })

  }

  PegarUmEnfermeiroPorEmail(email_enfermeiro: string, token?: string): Promise<Enfermeiro | null> {

    return new Promise((resolve, reject) => {
      if (token) this._api.setAuthorization(token);

      if (!email_enfermeiro) {
        resolve(null);
        return
      }

      this._api.get('/api/usuarios', { tipoUsuario: 'enfermeiro', email: email_enfermeiro}).subscribe((result) => {
        if (!result.data) resolve(null)

        let enfermeiros: Array<Enfermeiro> = result.data

        if (enfermeiros.length != 0) {
          let enfermeiro = enfermeiros[0] 

          if (enfermeiro.idade) enfermeiro.idade = this.ConvertTimeStampToDate(enfermeiro.idade) 

          resolve(enfermeiro) 

        } else resolve(null)

      }, err => reject(err))

    })

  }

  PegarUmEnfermeiroPorId(id_enfermeiro: string): Promise<Enfermeiro> {

    return new Promise((resolve, reject) => {

      this._api.get(`/api/usuarios/${id_enfermeiro}`).subscribe(result => {

        let enfermeiro: Enfermeiro = result.data

        if (enfermeiro.idade) enfermeiro.idade = this.ConvertTimeStampToDate(enfermeiro.idade) 

        resolve(enfermeiro)

      }, err => reject(err))

    })

  }

  PegarListaPacientesDeUmEnfermeiro(enfermeiroId: string): Observable<Paciente[]> {
    
    return Observable.create(async (observer: any) => {

      try {

        this._api.get('/api/usuarios', { tipoUsuario: 'paciente', enfermeiro: enfermeiroId, detailCartao: true }).subscribe(result => {
          
          var pacientes: Array<Paciente> = result.data

          var pacientesEditado = pacientes.map((item) => {

            item.cartao_gestante = (item.cartao_gestante || []).map(cartao => this.FormatCartaoGestanteToDate(cartao))

            item.ultimo_cartao = item.cartao_gestante.length > 0 ? item.cartao_gestante[0] : undefined

            if (item.idade) item.idade = this.ConvertTimeStampToDate(item.idade)
            
            return item

          })

          pacientesEditado.sort((a,b) =>  a.primeiro_nome > b.primeiro_nome ? 1 : -1)

          observer.next(pacientesEditado) 

        })

      } catch (error) {
        observer.error(error) 
      }
      
    })

  }

  PegarListaPacientesDeUmEnfermeiroPage(page: number = 1, limit: number = 12,  search: object = {}): Observable<Pagination<Paciente>> {
  
    return Observable.create(async (observer: any) => {
      try {
        const postData = { ...search, page, limit, detailCartao: true, tipoUsuario: 'paciente'}

        this._api.get('/api/usuarios/page', postData).subscribe(result => {
          const { page, data, total, totalInPage, totalPages } = result
            
          var pacientes: Array<Paciente> = data

          var pacientesEditado = pacientes.map((item) => {

            item.cartao_gestante = (item.cartao_gestante || []).map(cartao => this.FormatCartaoGestanteToDate(cartao))

            item.ultimo_cartao = item.cartao_gestante.length > 0 ? item.cartao_gestante[0] : undefined

            if (item.idade) item.idade = this.ConvertTimeStampToDate(item.idade)
            
            return item

          })

          pacientesEditado.sort((a,b) =>  a.primeiro_nome > b.primeiro_nome ? 1 : -1)

          const pagination: Pagination<Paciente> = {
            data: pacientesEditado,
            totalInPage,
            totalPages,
            total,
            page
          }

          observer.next(pagination) 

        })

      } catch (error) {
        observer.error(error) 
      }
    })
  }

  PegarCartoesGestanteDoEnfermeiro(email_enfermeiro: string ): Promise<any> {
    return new Promise((resolve, reject) => {
        // this.firestore.collection('cartao_gestante', ref => ref.where())
    })
  }

  ProximaConsultaEnfermeiro(email_enfermeiro: string): Promise<ConsultaPaciente | null> {

    return new Promise(async (resolve, reject) => {

      try {
          var consultas = await this.ListaConsultasEnfermeiro(email_enfermeiro)

          var proximas_consultas = consultas.proximas 
          
          if (proximas_consultas.length > 0) resolve(proximas_consultas[0]) 
          else resolve(null) 

      } catch (error) {

        reject(error)

      }

    })

  }

  AtualizarEnfermeiro(enfermeiro: Enfermeiro): Promise<Enfermeiro> {

    return new Promise((resolve, reject) => {

      this._api.put(`/api/usuarios/${enfermeiro.id}`, enfermeiro).subscribe(result => {

        let enfermeiro: Enfermeiro = result.data

        resolve(enfermeiro) 
        
      }, err => reject(err))

    })

  }

  DeletarEnfermeiro(enfermeiro: Enfermeiro): Promise<Boolean> {
    return new Promise((resolve, reject) => {

      this._api.delete('/api/usuarios', enfermeiro.id!).subscribe(() => {

        resolve(true) 

      }, err => reject(err)) 

    })
  }  

  /*****************************************************************************************************************************************
   * 
   *                                                             Secretarias
   * 
   *****************************************************************************************************************************************/
  CadastrarSecretaria(secretaria: Secretaria): Promise<any> {

    return new Promise(async (resolve, reject) => {

      this._api.post('/api/usuarios', secretaria).subscribe(result => {

        let secretaria: Secretaria = result.data

        if (!secretaria) reject("Nenhuma secretaria encontrada")

        resolve(secretaria) 

      }, err => reject(err))

    })

  }
  
  PegarListaSecretarias(): Observable<Secretaria[]> {

    return Observable.create((observer: any) => {

      this._api.get('/api/usuarios', { tipoUsuario: 'secretaria' }).subscribe(result => {

        let secretarias: Array<Secretaria> = result.data

        if (!secretarias.length) observer.error('Nenhuma secretaria encontrada')

        observer.next(secretarias)

        observer.complete()

      }, err => observer.error(err))

    })

  }

  AtualizarSecretaria(secretaria: Secretaria): Promise<Secretaria> {

    return new Promise((resolve, reject) => {

      this._api.put(`/api/usuarios/${secretaria.id}`, secretaria).subscribe(result => {

        let secretaria: Secretaria = result.data

        resolve(secretaria) 
        
      }, err => reject(err))

    })

  }

  DeletarSecretaria(secretaria: Secretaria): Promise<Boolean> {
    return new Promise((resolve, reject) => {

      this._api.delete('/api/usuarios', secretaria.id!).subscribe(() => {

        resolve(true) 

      }, err => reject(err)) 

    })
  }

  PegarTotalSecretarias(): Promise<number> {
        
    return new Promise((resolve, reject) => {

      this._api.get('/api/usuarios', { tipoUsuario: 'secretaria', count: true }).subscribe(result => {
          
        let secretariasCount: number = result.data

        resolve(secretariasCount)

      }, err => reject(err))

    })

  }

  PegarSecretariaPorId(id: string): Promise<Secretaria> {

    return new Promise((resolve, reject) => {

      this._api.get(`/api/usuarios/${id}`).subscribe(result => {

        const secretaria: Secretaria = result.data

        if (secretaria.idade) secretaria.idade = this.ConvertTimeStampToDate(secretaria.idade)

        resolve(secretaria)

      }, err => reject(err))

    })
  }

  PegarUmaSecretariaPorEmail(email_secretaria: string, token?: string): Promise<Secretaria | null> {
    return new Promise((resolve, reject) => {
      if (token) this._api.setAuthorization(token);

      if (!email_secretaria) {
        resolve(null);
        return
      }

      this._api.get('/api/usuarios', { tipoUsuario: 'secretaria', email: email_secretaria}).subscribe((result) => {
        if (!result.data) resolve(null)

        let secretarias: Array<Secretaria> = result.data

        if (secretarias.length != 0) {
          let secretaria = secretarias[0] 

          if (secretaria.idade) secretaria.idade = this.ConvertTimeStampToDate(secretaria.idade) 

          resolve(secretaria) 

        } else resolve(null)

      }, err => reject(err))

    })
  }

  PegarListaPacientesPorSecretaria(secretariaId: string): Observable<Paciente[]> {
    
    return Observable.create(async (observer: any) => {

      try {

        this._api.get('/api/usuarios', { tipoUsuario: 'paciente', secretaria: secretariaId, detailCartao: true }).subscribe(result => {
          
          var pacientes: Array<Paciente> = result.data

          var pacientesEditado = pacientes.map((item) => {

            item.cartao_gestante = (item.cartao_gestante || []).map(cartao => this.FormatCartaoGestanteToDate(cartao))

            item.ultimo_cartao = item.cartao_gestante.length > 0 ? item.cartao_gestante[0] : undefined

            if (item.idade) item.idade = this.ConvertTimeStampToDate(item.idade)
            
            return item

          })

          pacientesEditado.sort((a,b) =>  a.primeiro_nome > b.primeiro_nome ? 1 : -1)

          observer.next(pacientesEditado) 

        })

      } catch (error) {
        observer.error(error) 
      }
      
    })

  }

  PegarListaPacientesPorSecretariaPage(page: number = 1, limit: number = 12, search: object = {}): Observable<Pagination<Paciente>> {
    
      return Observable.create(async (observer: any) => {
        try {
          const postData = { ...search, page, limit, detailCartao: true, tipoUsuario: 'paciente'}

          this._api.get('/api/usuarios/page', postData).subscribe(result => {
            const { page, data, total, totalInPage, totalPages } = result
              
            var pacientes: Array<Paciente> = data
  
            var pacientesEditado = pacientes.map((item) => {
  
              item.cartao_gestante = (item.cartao_gestante || []).map(cartao => this.FormatCartaoGestanteToDate(cartao))
              
              item.ultimo_cartao = item.cartao_gestante.length > 0 ? item.cartao_gestante[0] : undefined
  
              if (item.idade) item.idade = this.ConvertTimeStampToDate(item.idade)
              
              return item
  
            })
  
            pacientesEditado.sort((a,b) =>  a.primeiro_nome > b.primeiro_nome ? 1 : -1)
  
            const pagination: Pagination<Paciente> = {
              data: pacientesEditado,
              totalInPage,
              totalPages,
              total,
              page
            }
  
            observer.next(pagination) 
  
          })
  
        } catch (error) {
          observer.error(error) 
        }
      })
    }

  /*****************************************************************************************************************************************
   * 
   *                                                             PACIENTES
   * 
   *****************************************************************************************************************************************/
  AtualizarQuantPacienteDoMedico(id_medico: string, value: number): Promise<Medico> {

    return new Promise(async (resolve, reject) => {

      try {

        let medico = await this.PegarUmMedicoPorId(id_medico)

        medico.n_pacientes = (medico.n_pacientes || 0) + value

        let medicoAtualizado = await this.AtualizarMedico(medico)

        resolve(medicoAtualizado)

      } catch (error) {

        reject(error)

      }

    })

  } 
  
  AtualizarQuantPacienteDoEnfermeiro(id_enfermeiro: string, value: number): Promise<Enfermeiro> {

    return new Promise(async (resolve, reject) => {

      try {

        let enfermeiro = await this.PegarUmEnfermeiroPorId(id_enfermeiro)

        enfermeiro.n_pacientes = (enfermeiro.n_pacientes || 0) + value

        let enfermeiroAtualizado = await this.AtualizarEnfermeiro(enfermeiro)

        resolve(enfermeiroAtualizado)

      } catch (error) {

        reject(error)

      }

    })

  }

  CadastrarPaciente(paciente: Paciente): Promise<Paciente> {

    return new Promise(async (resolve, reject) => {

      this._api.post('/api/usuarios?full=true', paciente).subscribe(async result => {

        let paciente: Paciente = result.data

        resolve(paciente)

      }, err => reject(err))

    })

  }

  PegarTotalPacientes(): Promise<number> {
        
    return new Promise((resolve, reject) => {

      this._api.get('/api/usuarios', { tipoUsuario: 'paciente', count: true }).subscribe(result => {
          
        let secretariasCount: number = result.data

        resolve(secretariasCount)

      }, err => reject(err))
      
    })

  }

  PegarDadosExtraPaciente(id_paciente: string): Promise<CartaoGestante[]> {

    return new Promise(async (resolve, reject) => {

      try {
        
        const paciente: Paciente = await this.PegarPacientePorId(id_paciente)

        const cartao_gestante = (paciente.cartao_gestante || []).filter(item => { return (!item.hasOwnProperty('encerrado') || item.encerrado !== true) && item.hasOwnProperty('ativado') && item.ativado === true })

        resolve(cartao_gestante)

      } catch (error) {

        reject(error)

      }

    })
  }

  PegarListaPacientes(infoCompleta: boolean = false): Observable<Paciente[]> {

    return Observable.create((observer: any) => {

      let query = { tipoUsuario: 'paciente', detailCartao: false }

      if (infoCompleta) query.detailCartao = true

      this._api.get('/api/usuarios', query).subscribe(result => {

        var pacientes: Array<Paciente> = result.data

        if (!pacientes.length) observer.next([])

        var pacientesEditado = pacientes.map((item) => {

          item.cartao_gestante = (item.cartao_gestante || []).map(cartao => this.FormatCartaoGestanteToDate(cartao))

          item.ultimo_cartao = item.cartao_gestante.length > 0 ? item.cartao_gestante[0] : undefined

          if (item.idade) item.idade = this.ConvertTimeStampToDate(item.idade)
          
          return item

        })

        pacientesEditado.sort((a, b) => a.primeiro_nome > b.primeiro_nome ? 1 : -1)

        observer.next(pacientesEditado ? pacientesEditado : [])

        observer.complete()

      })

    })

  }

  PegarPacientePorId(id: string): Promise<Paciente> {

    return new Promise((resolve, reject) => {

      this._api.get(`/api/usuarios/${id}`).subscribe((result) => {

        let paciente: Paciente = result.data

        if (paciente.idade) paciente.idade = this.ConvertTimeStampToDate(paciente.idade)

        paciente.cartao_gestante = (paciente.cartao_gestante || []).map(cartao => this.FormatCartaoGestanteToDate(cartao))

        resolve(paciente)

      }, err => reject(err))

    })
  }

  PegarPacientePorIdCompletasso(id: string): Promise<Paciente> {

    return new Promise((resolve, reject) => {

      this._api.get(`/api/usuarios/${id}`).subscribe(result => {

        const paciente: Paciente = result.data

        if (paciente.idade) paciente.idade = this.ConvertTimeStampToDate(paciente.idade)

        paciente.cartao_gestante = (paciente.cartao_gestante || []).map(cartao => this.FormatCartaoGestanteToDate(cartao))

        resolve(paciente)

      }, err => reject(err))

    })

  }

  PegarPacientePorIdCompletassoObservable(id: string): Observable<Paciente> {

    return Observable.create((observer: any) => {

      this.PegarPacientePorIdCompletasso(id)
        .then(paciente => {
          observer.next(paciente)
          observer.complete()
        })
        .catch(err => observer.error(err))

    })

  }

  PegarPacientePorEmail(paciente_email: string,token?: string): Promise<Paciente> {

    return new Promise((resolve, reject) => {
      if (token) this._api.setAuthorization(token);

      this._api.get('/api/usuarios', { tipoUsuario: 'paciente', email: paciente_email, detailCartao: true }).subscribe(result => {

        if (!result.data.length) {
          reject('Nenhum paciente encontrado')
          return
        }
          
        const pacientes: Array<Paciente> = result.data

        const paciente: Paciente = pacientes[0]

        if (paciente.idade) paciente.idade = this.ConvertTimeStampToDate(paciente.idade)

        paciente.cartao_gestante = (paciente.cartao_gestante || []).map(cartao => this.FormatCartaoGestanteToDate(cartao))
        
        paciente.ultimo_cartao = paciente.cartao_gestante.length > 0 ? paciente.cartao_gestante[0] : undefined

        resolve(paciente)

      }, err => reject(err))

    })

  }

  PegarIdDoPacientePorEmail(paciente_email: string): Promise<string> {

    return new Promise((resolve, reject) => {

      this.PegarPacientePorEmail(paciente_email)
        .then(paciente => resolve(paciente.id!))
        .catch(err => reject(err))

    })

  }

  ProximaConsultaPaciente(id_paciente: string): Promise<ConsultaPaciente | null> {

    return new Promise(async (resolve, reject) => {

      await this.ListaConsultasPaciente(id_paciente).then(consultas => {

        var proxima_consulta = consultas.proximas.length > 0 ? consultas.proximas[0] : null

        resolve(proxima_consulta)

      }).catch(err => reject(err))

    })

  }

  AtualizarPaciente(paciente: Paciente): Promise<Paciente> {

    return new Promise((resolve, reject) => {

      this._api.put(`/api/usuarios/${paciente.id}`, paciente).subscribe(result => {

        const paciente: Paciente = result.data

        resolve(paciente)

      }, err => reject(err))
    })
  }

  DeletarPaciente(paciente_email: string, id?: string): Promise<Boolean> {

    return new Promise(async (resolve, reject) => {

      try {
        // Listar todos os cartões do paciente 
        var paciente = await this.PegarPacientePorEmail(paciente_email)

        if (id && paciente.id !== id) var paciente = await this.PegarPacientePorId(id)

        if (paciente.id) {
          
          this._api.delete('/api/usuarios', paciente.id).subscribe(async () => {

            resolve(true)

          }, err => reject(err))

        } else {
          
          reject('Paciente não encontrado')
        
        }

      } catch (error) {
        reject(error)
      }
    })

  }

  AtualizarUrlPerfil(id_usuario: string, url: string): Promise<Usuario> {

    return new Promise((resolve, reject) => {

      this._api.get(`/api/usuarios/${id_usuario}`).subscribe(result => {

        const perfil: Usuario = result.data

        perfil.url = url

        this._api.put(`/api/usuarios/${id_usuario}`, perfil).subscribe(result => {

          const perfilAtualizado: Usuario = result.data

          resolve(perfilAtualizado)

        }, err => reject(err))

      }, err => reject(err))

    })

  }
  

  /*****************************************************************************************************************************************
   * 
   *                                                             EXAMES
   * 
   *****************************************************************************************************************************************/
  private async _uploadPdf(cartaoId: string, file: File): Promise<string> {
    const token = localStorage.getItem('accessToken') || '';
    const callbackUrl = `${this._api.baseUrl}/api/exames/arquivos/getTokenUpload?cartaoId=${encodeURIComponent(cartaoId)}`;

    // Passo 1 — obter clientToken do servidor
    const tokenBody = {
      type: 'blob.generate-client-token',
      payload: {
        pathname: file.name,
        callbackUrl,
        multipart: false,
        clientPayload: JSON.stringify({ token })
      }
    };

    const tokenHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    const tokenResult: any = await this._http
      .post(`${this._api.baseUrl}/api/exames/arquivos/getTokenUpload?cartaoId=${encodeURIComponent(cartaoId)}`, tokenBody, { headers: tokenHeaders })
      .toPromise();

    const clientToken: string = tokenResult.clientToken;

    // Passo 2 — enviar o arquivo direto ao Vercel Blob
    const uploadHeaders = new HttpHeaders({
      'Authorization': `Bearer ${clientToken}`,
      'Content-Type': 'application/pdf'
    });

    const uploadResult: any = await this._http
      .put(`https://blob.vercel-storage.com/${tokenResult.pathname}`, file, { headers: uploadHeaders })
      .toPromise();

    return uploadResult.url;
  }

  AnalisarPDFExames(cartaoId: string, file: File, trimestre: number): Promise<{ exames: ExameConfiance[], arquivoId: string }> {
    return new Promise(async (resolve, reject) => {
      try {
        const blobUrl = await this._uploadPdf(cartaoId, file);

        this._api.post('/api/exames/arquivos/analyzeLaboratorial', { cartaoId, blobUrl, trimestre, usar_analise: true }).subscribe((result: AnalizePDFResponse) => {
          const arquivoId = result.exams.length ? result.exams[0].arquivoId : '';

          if (!result.exams.length) resolve({ exames: [], arquivoId })

          let exames: ExameConfiance[] = [];

          result.exams.forEach((resultPdf) => {
            if (!resultPdf.results.length) return

            resultPdf.results.forEach(exam => {
              exames.push(exam)
            })
          })

          resolve({ exames, arquivoId })
        }, err => reject(err))
      } catch (err) {
        reject(err)
      }
    })
  }

  AnalisarPDFUltrasonografia(cartaoId: string, file: File): Promise<{ ultrasonografias: UltrasonografiaConfiance[], arquivoId: string }> {
    return new Promise(async (resolve, reject) => {
      try { 
        const blobUrl = await this._uploadPdf(cartaoId, file);

        this._api.post('/api/exames/arquivos/analyzeUltrasom', { cartaoId, blobUrl, usar_analise: true }).subscribe((result: AnalizePDFUltrasonograResponse) => {
          if (!result.exams.length) reject('Nenhum resultado encontrado')

          const arquivoId = result.exams.length ? result.exams[0].arquivoId : '';
          let ultrasonografias: UltrasonografiaConfiance[] = []

          result.exams.forEach((resultPdf) => {
            if (!resultPdf.results) return

            if (Array.isArray(resultPdf.results)) {
              ultrasonografias = ultrasonografias.concat(resultPdf.results)
            } else {
              ultrasonografias.push(resultPdf.results)
            }
          })

          logger.log('ultrasonografias', ultrasonografias)

          resolve({ ultrasonografias, arquivoId })
        }, err => reject(err))
      } catch (err) {
        reject(err)
      }
    })
  }

  BuscarArquivoPDF(arquivoId: string): Promise<ArquivoAnalisado> {
    return new Promise((resolve, reject) => {
      this._api.get(`/api/exames/arquivos/${arquivoId}`).subscribe(result => {
        resolve(result.data || result);
      }, err => reject(err));
    });
  }

  DeletarArquivoPDF(arquivoId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this._api.delete('/api/exames/arquivos', arquivoId).subscribe(() => {
        resolve();
      }, err => reject(err));
    });
  }

  ReAnalisarLaboratorial(arquivoId: string): Promise<{ exames: ExameConfiance[], arquivoId: string }> {
    return new Promise((resolve, reject) => {
      this._api.get(`/api/exames/arquivos/analyzeLaboratorial/${arquivoId}`, { reanalisar: true }).subscribe((result) => {
        const arquivo: ArquivoAnalisado = result.data;
        if (!arquivo) { reject('Arquivo não encontrado'); return; }

        const arqId = arquivo.id || arquivoId;
        const exames: ExameConfiance[] = Array.isArray(arquivo.resultado) ? arquivo.resultado : [];

        resolve({ exames, arquivoId: arqId });
      }, err => reject(err));
    });
  }

  ReAnalisarUltrasom(arquivoId: string): Promise<{ ultrasonografias: UltrasonografiaConfiance[], arquivoId: string }> {
    return new Promise((resolve, reject) => {
      this._api.get(`/api/exames/arquivos/analyzeUltrasom/${arquivoId}`, { reanalisar: true }).subscribe((result) => {
        const arquivo: ArquivoAnalisado = result.data;
        if (!arquivo) { reject('Arquivo não encontrado'); return; }

        const arqId = arquivo.id || arquivoId;
        const ultrasonografias: UltrasonografiaConfiance[] = Array.isArray(arquivo.resultado)
          ? arquivo.resultado
          : arquivo.resultado ? [arquivo.resultado] : [];

        resolve({ ultrasonografias, arquivoId: arqId });
      }, err => reject(err));
    });
  }

  MudarStatusArquivo(arquivoId: string, status: 'pendente' | 'processado' | 'utilizado'): Promise<void> {
    return new Promise((resolve, reject) => {
      this._api.patch(`/api/exames/arquivos/${arquivoId}/status`, { status }).subscribe(() => {
        resolve();
      }, err => reject(err));
    });
  }

  GerarPDF(cartaoId: string): Promise<{ url: string }> {
    return new Promise((resolve, reject) => {
      this._api.get(`/api/cartoes/${cartaoId}/pdf`, {}).subscribe(result => {
        resolve(result);
      }, err => reject(err));
    });
  }

  AlterarExamesLaboratorios(cartao_id: string, todosExames: Exames, examesLaboratorios: ExameLaboratorio): Promise<Exames> {

    return new Promise((resolve, reject) => {
      const cartaoUpd = { ...todosExames, laboratorio: examesLaboratorios }

      this._api.post(`/api/cartoes/${cartao_id}/exames`, cartaoUpd).subscribe(result => {

        const exames: Exames = result.data

        resolve(exames)

      }, err => reject(err))

    })

  }

  RemoverExameLaboratorios(cartao_id: string, exame: ExameLaboratorio, todos_exames: Exames): Promise<Exames> {

    return new Promise((resolve, reject) => {
      let index = todos_exames.laboratorio.indexOf(exame)
      todos_exames.laboratorio.splice(index, 1)

      this._api.post(`/api/cartoes/${cartao_id}/exames`, todos_exames).subscribe(result => {
        
        const exames: Exames = result.data
        resolve(exames)
        
      }, err => reject(err))

    })

  }
  
  InserirExameClinico(cartao_id: string, exame: any, todos_exames: any): Promise<Exames> {

    return new Promise((resolve, reject) => {

      var novos_exames = todos_exames
      novos_exames.clinicos.push(exame)

      this._api.post(`/api/cartoes/${cartao_id}/exames`, novos_exames).subscribe(result => {

        const exames: Exames = result.data

        resolve(exames)

      }, err => reject(err))

    })

  }

  EditarExameClinico(cartao_id: string, exameOld: any, exameNew: any, todos_exames: Exames): Promise<any> {

    let index = todos_exames.clinicos.indexOf(exameOld)
    todos_exames.clinicos[index] = exameNew

    return new Promise((resolve, reject) => {

      this._api.post(`/api/cartoes/${cartao_id}/exames`, todos_exames).subscribe(result => {

        const exames: Exames = result.data

        resolve(exames)

      }, err => reject(err))

    })

  }

  InserirLab(cartao_id: string, exame: ExameLaboratorio[], todos_exames: Exames): Promise<Exames> {

    return new Promise((resolve, reject) => {

      var novos_exames = exame
      var exames_anteriores = todos_exames.laboratorio
      var lab_atualizado = []

      var pos = 0
      novos_exames.forEach(element => {

        var item = exames_anteriores.find(item => item.name == element.name)
        var index = exames_anteriores.indexOf(item)

        if (index == -1) {
          exames_anteriores.splice(pos, 0, element)
        } else {
          let arquivo_res1 = null;
          let arquivo_res2 = null;
          let arquivo_res3 = null;

          if (element.arquivo_res1) arquivo_res1 = element.arquivo_res1
          else if (exames_anteriores[index].arquivo_res1) arquivo_res1 = exames_anteriores[index].arquivo_res1

          if (element.arquivo_res2) arquivo_res2 = element.arquivo_res2
          else if (exames_anteriores[index].arquivo_res2) arquivo_res2 = exames_anteriores[index].arquivo_res2

          if (element.arquivo_res3) arquivo_res3 = element.arquivo_res3
          else if (exames_anteriores[index].arquivo_res3) arquivo_res3 = exames_anteriores[index].arquivo_res3

          var aux = {
            name: element.name,
            data_limite_tri1: exames_anteriores[index].data_limite_tri1 == '' ? element.data_limite_tri1 : exames_anteriores[index].data_limite_tri1,
            data_limite_tri2: exames_anteriores[index].data_limite_tri2 == '' ? element.data_limite_tri2 : exames_anteriores[index].data_limite_tri2,
            data_limite_tri3: exames_anteriores[index].data_limite_tri3 == '' ? element.data_limite_tri3 : exames_anteriores[index].data_limite_tri3,
            arquivo_res1,
            arquivo_res2,
            arquivo_res3,
            datas: {
              data1: exames_anteriores[index].datas.data1 == '' ? element.datas.data1 : exames_anteriores[index].datas.data1,
              data2: exames_anteriores[index].datas.data2 == '' ? element.datas.data2 : exames_anteriores[index].datas.data2,
              data3: exames_anteriores[index].datas.data3 == '' ? element.datas.data3 : exames_anteriores[index].datas.data3,
              res1: exames_anteriores[index].datas.res1 == '' ? element.datas.res1 : exames_anteriores[index].datas.res1,
              res2: exames_anteriores[index].datas.res2 == '' ? element.datas.res2 : exames_anteriores[index].datas.res2,
              res3: exames_anteriores[index].datas.res3 == '' ? element.datas.res3 : exames_anteriores[index].datas.res3,
            }
          }

          exames_anteriores[index] = aux
        }

        pos++

      })

      let exameBlackList = ['Protoparasitologia', 'Parasitológico']
      exames_anteriores = exames_anteriores.filter(item => {

        if (exameBlackList.indexOf(item.name) > -1) return false

        return true

      })

      var exames_atualizados = todos_exames
      exames_atualizados.laboratorio = exames_anteriores

      this._api.post(`/api/cartoes/${cartao_id}/exames`, exames_atualizados).subscribe(result => {
        
        const exames: Exames = result.data

        resolve(exames)
        
      }, err => reject(err))

    })

  }

  AlterarValorExameLab(cartao_id: string, trimestre: number, allTrimestre: boolean = false, valor: string, exame: any, todos_os_exames: Exames): Promise<Exames> {
    
    return new Promise((resolve, reject) => {

      var todos_exames = todos_os_exames
      var laboratoriais = todos_exames.laboratorio

      var aux = laboratoriais.filter(item => item.name == exame.name)
      var exame_a_editar = aux[0]

      var index = laboratoriais.indexOf(exame_a_editar)

      if (allTrimestre) {
        exame_a_editar.datas[`res1`] = valor
        exame_a_editar.datas[`res2`] = valor
        exame_a_editar.datas[`res3`] = valor

        if (!valor) {
          exame_a_editar.arquivo_res1 = null
          exame_a_editar.arquivo_res2 = null
          exame_a_editar.arquivo_res3 = null
          exame_a_editar.datas[`data1`] = null
          exame_a_editar.datas[`data2`] = null
          exame_a_editar.datas[`data3`] = null
        }
      } else {
        switch (trimestre) {
          case 1:
            exame_a_editar.datas[`res1`] = valor
            if (!valor) {
              exame_a_editar.arquivo_res1 = null
              exame_a_editar.datas[`data1`] = null
            }
            break;
          case 2:
            exame_a_editar.datas[`res2`] = valor
            if (!valor) {
              exame_a_editar.arquivo_res2 = null
              exame_a_editar.datas[`data2`] = null
            }
            break;
          case 3:
            exame_a_editar.datas[`res3`] = valor
            if (!valor) {
              exame_a_editar.arquivo_res3 = null
              exame_a_editar.datas[`data3`] = null
            }
            break;
        }
      }

      laboratoriais[index] = exame_a_editar
      todos_exames.laboratorio = laboratoriais

      this._api.post(`/api/cartoes/${cartao_id}/exames`, todos_exames).subscribe(result => {

        const exames: Exames = result.data

        resolve(exames)

      }, err => reject(err))

    })

  }

  AlterarTrimestreExameLab(cartao_id: string, trimestre: number, valor: string, todos_os_exames: Exames): Promise<ExameLaboratorio[]> {

    return new Promise((resolve, reject) => {

      var todos_exames = todos_os_exames
      var novadata = valor

      var todos_exames_laboratorio = todos_exames.laboratorio.map((item) => {

        switch (trimestre) {
          case 1:
            item.datas['data1'] = novadata
          case 2:
            item.datas['data2'] = novadata
          case 3:
            item.datas['data3'] = novadata
        }

        return item

      })

      const cartaoUpd = { ...todos_exames, laboratorio: todos_exames_laboratorio }

      this._api.post(`/api/cartoes/${cartao_id}/exames`, cartaoUpd).subscribe(result => {

        const exames: Exames = result.data

        resolve(exames.laboratorio)

      }, err => reject(err))

    })

  }

  InserirUSG(cartao_id: string, exame: any, todos_exames: any): Promise<Exames> {

    return new Promise((resolve, reject) => {

      var novos_exames = todos_exames; 
      novos_exames.ultrasom.push(exame); 

      this._api.post(`/api/cartoes/${cartao_id}/exames`, novos_exames).subscribe(result => {
        
        const exames: Exames = result.data

        if (!exames) reject('Erro ao pegar exames')
        
        resolve(exames)

      }, err => reject(err))
          
    });

  }

  AlterarUSG(cartao_id: string, exames_ultrasom: ExameUltrasom[], todos_exames: Exames): Promise<Exames> {

    return new Promise((resolve, reject) => {

      var novos_exames = todos_exames; 
      novos_exames.ultrasom = exames_ultrasom; 

      this._api.post(`/api/cartoes/${cartao_id}/exames`, novos_exames).subscribe(result => {
        
        const exames: Exames = result.data

        if (!exames) reject('Erro ao pegar exames')
        
        resolve(exames)

      }, err => reject(err))
          
    });

  }

  InserirOutros(cartao_id: string, exame: any, todos_exames: any): Promise<Exames> {
    
    return new Promise((resolve, reject) => {
      
      var novos_exames = todos_exames;
      novos_exames.outros.push(exame);

      this._api.post(`/api/cartoes/${cartao_id}/exames`, novos_exames).subscribe(result => {

        const exames: Exames = result.data

        if (!exames) reject('Erro ao pegar exames')

        resolve(exames);

      }, err => reject(err))
    
    });
  
  }

  
  /*****************************************************************************************************************************************
   * 
   *                                                             CONSULTAS
   * 
   *****************************************************************************************************************************************/
  CriarConsulta(email_paciente: string, email_medico: string, id_cartao_gestante: string, dados_consulta: any): Promise<ConsultaPaciente[]> {

    return new Promise((resolve, reject) => {

      var aux: ConsultaPaciente = ConsultaPaciente.create(dados_consulta, email_medico, email_paciente, id_cartao_gestante)

      this._api.post(`/api/cartoes/${id_cartao_gestante}/consultas`, aux).subscribe(result => {
        const consultas: Array<ConsultaPaciente> = result.data

        resolve(consultas)
      }, err => reject(err))

    })

  }

  ListaConsultasMedico(email_medico: string): Promise<ListaConsulta> {

    return new Promise(async (resolve, reject) => {

      try {

        var medico = await this.PegarUmMedicoPorEmail(email_medico)

        this._api.get('/api/cartoes/consultas', { medico: medico!.id }).subscribe(async result => {

          const cartoes: Array<CartaoGestante> = result.data

          if (!cartoes.length) reject('Nenhuma consulta encontrada para esse médico')

          const consultas: Array<ConsultaPaciente> = []

          cartoes.forEach(cartao => {
            cartao.consultas.forEach(item => {
              consultas.push(item)
            })
          })

          var consultas_filtradas = await this.FilterByActiveCard(consultas)

          var ordenado = this.OrderByDate(consultas_filtradas)

          var nomesPacientes: Promise<Paciente>[] = ordenado.map(item => this.PegarPacientePorId(item.paciente_id))

          var allPromises = await Promise.all(nomesPacientes)

          var consulta_editada: Array<ConsultaPaciente> = allPromises.map((item, index) => {
            return { ...ordenado[index], nome_paciente: `${item.primeiro_nome} ${item.sobrenome}` }
          })

          var consultas_divididas = this.DivideNextAndPrevious(consulta_editada)

          resolve(consultas_divididas)

        }, err => reject(err))

      } catch (error) {

        reject(error)

      }

    })

  }

  ListaConsultasEnfermeiro(email_enfermeiro: string): Promise<ListaConsulta> {

    return new Promise(async (resolve, reject) => {

      try {

        var enfermeiro = await this.PegarUmEnfermeiroPorEmail(email_enfermeiro)

        this._api.get('/api/cartoes/consultas', { enfermeiro: enfermeiro!.id }).subscribe(async result => {

          const cartoes: Array<CartaoGestante> = result.data

          if (!cartoes.length) reject('Nenhuma consulta encontrada para esse enfermeiro')

          const consultas: Array<ConsultaPaciente> = []

          cartoes.forEach(cartao => {
            cartao.consultas.forEach(item => {
              consultas.push(item)
            })
          })

          var consultas_filtradas = await this.FilterByActiveCard(consultas)

          var ordenado = this.OrderByDate(consultas_filtradas)

          var nomesPacientes: Promise<Paciente>[] = ordenado.map(item => this.PegarPacientePorId(item.paciente_id))

          var allPromises = await Promise.all(nomesPacientes)

          var consulta_editada: Array<ConsultaPaciente> = allPromises.map((item, index) => {
            return { ...ordenado[index], nome_paciente: `${item.primeiro_nome} ${item.sobrenome}` }
          })

          var consultas_divididas = this.DivideNextAndPrevious(consulta_editada)

          resolve(consultas_divididas)

        }, err => reject(err))

      } catch (error) {

        reject(error)

      }

    })

  }

  ListaConsultasPaciente(id_paciente: string): Promise<ListaConsulta> {

    return new Promise((resolve, reject) => {

      this._api.get('/api/cartoes/consultas', { paciente: id_paciente }).subscribe(async result => {

        const cartoes: Array<CartaoGestante> = result.data

        if (!cartoes.length) reject('Nenhuma consulta encontrada para esse paciente')

        const consultas: Array<ConsultaPaciente> = []

        cartoes.forEach(cartao => {
          cartao.consultas.forEach(item => {
            consultas.push(item)
          })
        })

        var consultas_filtradas = await this.FilterByActiveCard(consultas)

        var ordenada = this.OrderByDate(consultas_filtradas)

        var consultas_divididas = this.DivideNextAndPrevious(ordenada)

        resolve(consultas_divididas)

      }, err => reject(err))

    })

  }

  ListaConsultasPorCartao(cartao_id: string): Promise<ConsultaPaciente[]> {

    return new Promise((resolve, reject) => {

      this._api.get(`/api/cartoes/${cartao_id}/consultas`).subscribe(async result => {

        const consultas: Array<ConsultaPaciente> = result.data

        var ordenado = this.OrderByDate(consultas)

        var nomesPacientes: Promise<Paciente>[] = ordenado.map(item => {
          return this.PegarPacientePorId(item.paciente_id)
        })

        var allPromises = await Promise.all(nomesPacientes)

        var consulta_editada: Array<ConsultaPaciente> = allPromises.map((item, index) => {
          return { ...ordenado[index], nome_paciente: `${item.primeiro_nome} ${item.sobrenome}` }
        })

        resolve(consulta_editada)

      }, err => reject(err))

    })

  }

  AlterarConsulta(id_consulta: string, consulta: ConsultaPaciente): Promise<ConsultaPaciente[]> {

    return new Promise((resolve, reject) => {

      this._api.put(`/api/cartoes/${consulta.cartao_paciente_id}/consultas/${id_consulta}`, consulta).subscribe(result => {

        const consultas: Array<ConsultaPaciente> = result.data 

        resolve(consultas)

      }, err => reject(err))
    
    });

  }

  DeletarConsulta(id_consulta: string): Promise<void> {

    return new Promise((resolve, reject) => {

      this._api.delete(`/api/cartoes/consultas`, id_consulta).subscribe(() => {
        resolve()
      }, err => reject(err))

    });

  }


  /*****************************************************************************************************************************************
   * 
   *                                                             CARTÃO GESTANTE
   * 
   *****************************************************************************************************************************************/
  CriarWebviewCartaoGestante(profissional: Medico | Enfermeiro, paciente: Paciente): Promise<string> {

    const scopes = ['read_cartao'];
    
    return new Promise((resolve, reject) => {
      this._api.post('/api/auth/accessAndCreateCartao', {
        profissional,
        paciente,
        scopes,
      }).subscribe(result => {

        const url:string = result.accessUrl

        resolve(url)
        
      }, err => reject(err))
    })
  
  }

  AdicionarCartaoAPaciente(id_paciente: string, email_medico?: string, email_enfermeiro?: string): Promise<CartaoGestante> {

    return new Promise(async (resolve, reject) => {

      var cartao = CartaoGestante.create()
      var aux = { ...cartao, paciente: id_paciente, medico: email_medico, enfermeiro: email_enfermeiro, used: false }

      this._api.post('/api/cartoes', aux).subscribe(result => {

        let cartao: CartaoGestante = result.data

        resolve(cartao)

      }, err => reject(err))

    })

  }

  LerUmCartaoGestante(id: string): Promise<CartaoGestante> {

    return new Promise((resolve, reject) => {

      this._api.get(`/api/cartoes/${id}`).subscribe(result => {

        if (!result.data) reject('Cartão não encontrado')

        let cartao: CartaoGestante = result.data

        var cartaoConverted = this.FormatCartaoGestanteToDate(cartao)

        resolve(cartaoConverted)

      }, err => reject(err))

    })

  }

  LerUmCartaoGestanteObservable(id: string): Observable<CartaoGestante> {

    return new Observable<CartaoGestante>((observer) => {
      this.LerUmCartaoGestante(id)
        .then(cartao => {
          observer.next(cartao)
          observer.complete()
        })
        .catch(err => observer.error(err))
    })

  }

  LerOCartaoAtivo(paciente_id: string): Promise<CartaoGestante> {

    return new Promise((resolve, reject) => {

      this._api.get('/api/cartoes', { paciente: paciente_id, cartaoAtivado: true, limit: 10 }).subscribe(result => {

        const cartoes: Array<CartaoGestante> = result.data

        if (cartoes.length != 0) {

          const cartao = cartoes[0]

          const cartaoConverted = this.FormatCartaoGestanteToDate(cartao)
          
          resolve(cartaoConverted)

        } else {
          reject('Nenhum cartão ativo encontrado para esse paciente')
        }

      }, err => reject(err))

    })

  }

  LerOCartaoEncerrado(paciente_id: string): Promise<CartaoGestante> {

    return new Promise((resolve, reject) => {

      this._api.get('/api/cartoes', { paciente: paciente_id, noDefault: true, limit: 10 }).subscribe(result => {

        const cartoes: Array<CartaoGestante> = result.data

        if (!cartoes.length) {
          reject('Nenhum cartão encerrado encontrado para esse paciente')
        } else {
          const cartao = cartoes[0]

          const cartaoConverted = this.FormatCartaoGestanteToDate(cartao)

          resolve(cartaoConverted)
        }

      }, err => reject(err))

    })

  }

  LerUltimoCartao(paciente_id: string): Promise<CartaoGestante> {

    return new Promise(async (resolve, reject) => {

      await this.LerOCartaoAtivo(paciente_id).then(cartaoAtivo => {

        return resolve(cartaoAtivo)

      }).catch(async () => {

        logger.log('Nenhum cartão ativo encontrado, buscando cartão encerrado...')

        const cartaoEncerrado = await this.LerOCartaoEncerrado(paciente_id)

        resolve(cartaoEncerrado)
        
      })

    })

  }

  AtivarUmCartao(paciente_email: string, cartao_id: string, paciente_id: string | null = null): Promise<CartaoGestante> {

    return new Promise(async (resolve, reject) => {

      try {

        var id_do_paciente = paciente_id
        if (id_do_paciente == null) id_do_paciente = await this.PegarIdDoPacientePorEmail(paciente_email)

        var cartao_ativo = await this.LerOCartaoAtivo(id_do_paciente)

        if (cartao_ativo == null) {

          if (!(await this.WasCardUsed(cartao_id))) {

            const cartao: CartaoGestante = await this.LerUmCartaoGestante(cartao_id)

            cartao.ativado = true

            this._api.put(`/api/cartoes/${cartao.id}`, cartao).subscribe(result => {

              const cartao: CartaoGestante = result.data

              resolve(cartao)

            }, err => reject(err))

          } else reject('Esse cartão já foi usado uma vez!')

        } else reject('já existe um cartão ativo pra esse paciente')

      } catch (error) {

        reject(error)

      }

    })

  }

  AtivarUmCartaoPeloMedico(medico_id: string, paciente_id: string, cartao_id: string): Promise<CartaoGestante> {

    return new Promise(async (resolve, reject) => {

      try {

        var medico = await this.PegarUmMedicoPorId(medico_id)

        var cartoes_usados = await this.TotalCartoesUsadosPorMedico(medico_id)

        if (medico.maximo_cartoes && medico.maximo_cartoes > (cartoes_usados || 0))
          this.AtivarUmCartao('', cartao_id, paciente_id)
            .then(res => resolve(res))
            .catch(err => reject(err))
            
        else reject('Usuário atingiu o limite de cartões!')

      } catch (error) {

        reject(error)

      }

    })

  }

  AtivarUmCartaoPeloEnfermeiro(enfermeiro_id: string, paciente_id: string, cartao_id: string): Promise<CartaoGestante> {

    return new Promise(async (resolve, reject) => {

      try {

        var enfermeiro = await this.PegarUmEnfermeiroPorId(enfermeiro_id)

        var cartoes_usados = await this.TotalCartoesUsadosPorEnfermeiro(enfermeiro_id)

        if (enfermeiro.maximo_cartoes && enfermeiro.maximo_cartoes > (cartoes_usados || 0))
          this.AtivarUmCartao('', cartao_id, paciente_id)
            .then(res => resolve(res))
            .catch(err => reject(err))
            
        else reject('Usuário atingiu o limite de cartões!')

      } catch (error) {

        reject(error)

      }

    })

  }

  DesativarUmCartao(cartao_id: string): Promise<CartaoGestante> {

    return new Promise((resolve, reject) => {

      this.LerUmCartaoGestante(cartao_id)
        .then(cartao => {

          cartao.ativado = false

          this._api.put(`/api/cartoes/${cartao_id}`, cartao).subscribe(result => {

            const cartao: CartaoGestante = result.data

            resolve(cartao)

          }, err => reject(err))

        })
        .catch(err => reject(err))

    })

  }

  RegistrarEncerramento(cartao_id: string, encerramentoObj: object): Promise<CartaoGestante> {

    return new Promise((resolve, reject) => {

      const cartaoEncerrado = { ativado: false, encerrado: true, ...encerramentoObj }

      this.AtualizarCartao(cartao_id, cartaoEncerrado)
        .then(cartao => resolve(cartao))
        .catch(err => reject(err))

    })

  }

  AtualizarCartao(cartao_id: string, cartao_atualizado: any): Promise<CartaoGestante> {

    return new Promise((resolve, reject) => {

      this.LerUmCartaoGestante(cartao_id)
        .then(cartao => {

          cartao = { ...cartao, ...cartao_atualizado }

          this._api.put(`/api/cartoes/${cartao_id}`, cartao).subscribe(result => {

            const cartao: CartaoGestante = result.data

            resolve(cartao)

          }, err => reject(err))

        })
        .catch(err => reject(err))

    })

  }

  DeletarCartao(cartao_id: string): Promise<void> {
    
    return new Promise((resolve, reject) => {

      this._api.delete('/api/cartoes', cartao_id).subscribe(() => {
        resolve()
      }, err => reject(err))

    })

  }

  WasCardUsed(cartao_id: string): Promise<boolean> {

    return new Promise((resolve, reject) => {

      this._api.get(`/api/cartoes/${cartao_id}`).subscribe(result => {

        const cartao: CartaoGestante = result.data

        resolve(cartao && typeof cartao.used === 'boolean' ? cartao.used : true)

      })

    })

  }
}